import React from "react";
import { useTranslation } from "react-i18next";
import { FaBars } from "react-icons/fa";
import enIMG from "../../images/en.jpg";
import frIMG from "../../images/fr.jpg";
import { Nav, NavbarContainer, NavLogo, MobileIcon, MailIcon, NavMenu, NavItem, NavLinks, NavBtn, NavBtnLink,NavBtnLang,NavBarBtnContainer, LangImg, NavLangBtnCol } from "./NavbarElements";

const Navbar = ({ toggle }) => {

  const { t, i18n } = useTranslation();

  function handleClick(lang){
    i18n.changeLanguage(lang);
  }

  return (
    <>
      <Nav>
        <NavbarContainer>
          <NavLogo to="/">VIVARAM</NavLogo>
          <MobileIcon onClick={toggle}>
            <FaBars />
          </MobileIcon>
          <NavMenu>
            <NavItem>
              <NavLinks to="/"> {t('navHome.txt')} </NavLinks>
            </NavItem>
            <NavItem>
              <NavLinks to="/project"> {t('navProject.txt')}  </NavLinks>
            </NavItem>
            <NavItem>
              <NavLinks to="/team"> {t('navTeam.txt')}  </NavLinks>
            </NavItem>
            <NavItem>
              <NavLinks to="/donators"> {t('navDonators.txt')}  </NavLinks>
            </NavItem>
            <NavItem>
              <NavLinks to="/join"> {t('navJoin.txt')}  </NavLinks>
            </NavItem>
          </NavMenu>
          
          <NavBarBtnContainer>
  
          <NavBtn>
            <NavBtnLink to="/contact">
              <MailIcon />
              {t('navContact.txt')} 
            </NavBtnLink>
          </NavBtn>
          <NavLangBtnCol>
          <NavBtnLang onClick={()=>handleClick('en')}>
          <LangImg src={enIMG} alt="" />
          </NavBtnLang>
          <NavBtnLang onClick={()=>handleClick('fr')} >
          <LangImg src={frIMG} alt="" />
          </NavBtnLang>
          </NavLangBtnCol>
          </NavBarBtnContainer>
        </NavbarContainer>
      </Nav>
    </>
  );
};

export default Navbar;
